import React from "react";

import { Row, Col } from "react-bootstrap";

import Dropdown from "../UI/Dropdown/Dropdown";
import moment from "moment";

let odabirAkcije = [
  {
    key: 1,
    title: "Unesi posebnu evidenciju",
    value: "unos",
  },
  {
    key: 2,
    title: "Pregledaj posebne evidencije",
    value: "pregled",
  },
];

const date = moment(new Date()).format("DD.MM");

const ActionSection = ({
  currentStep,
  selectedAction,
  handleActionChange,
  role,
}) => {
  const formOptions = odabirAkcije.map((element) => (
    <option key={element.key} value={element.value}>
      {element.title}
    </option>
  ));

  // if ("15.05" > date && "15.06" < date && role === "ROLE_KORISNIK") {
  //   odabirAkcije = [
  //     {
  //       key: 2,
  //       title: "Pregledaj posebne evidencije",
  //       value: "pregled",
  //     },
  //   ];
  // }

  return (
    <div>
      {currentStep == 1 && (
        <Row>
          <Col xl={8} lg={10} md={12} className="steps-content">
            <Row className="row justify-content-center">
              <Col xl={6} lg={8} md={12} className="align-self-center">
                <Dropdown
                  hidden
                  onChange={handleActionChange}
                  value={selectedAction}
                  id={1}
                  center
                  label={"Odaberite akciju"}
                  asProperty="select"
                  map={formOptions}
                  text="Odabir akcije"
                  className="drop"
                  name="odabirAkcije"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ActionSection;
